/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import * as actionTypes from 'Front/actions/actionTypes'
const initState = {
  response: [],
  message: '',
  isClinicList: false,
  isClinicListError: false,
  ClinicList: false,
}

export default (state = initState, action = {}) => {
  switch (action.type) {
    case actionTypes.GET_CLINIC_LIST_REQUEST:
      return {
        ...state,
        message: '',
        isClinicList: false,
        isClinicListError: false,
      }
    case actionTypes.GET_CLINIC_LIST_SUCCESS:
      return {
        ...state,
        message: 'Clinic List successfully',
        ClinicList: action.payload.response,
        isClinicList: true,
        isClinicListError: false,
      }
    case actionTypes.GET_CLINIC_LIST_ERROR:
      return {
        ...state,
        response: action.payload.error,
        message: action.payload.error,
        isClinicList: false,
        isClinicListError: true
      }


    default:
      return state
  }
}
